import { api } from "@/constants"
import { getAuthHeader, serializeQueryParams } from "@/util"
import baseURL from "@/service/api"

const summary = {
  paymentReports: (params) => {
    const url = api.summary.paymentReports + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  paymentReportsDownload: (params) => {
    const url =
      api.summary.paymentReportsDownload + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  }
}
export default summary
